import React from 'react';

import { Trans } from '@lingui/react/macro';

import VideaLogoSm from '../../common-components/elements/icon/svgs/VideaBrandSm';

/**
 * Error page shown to magic link users when they encounter login issues
 * Provides a simple refresh option to retry the magic link flow
 */
export const MagicLinkErrorPage: React.FC = () => {
  const handleRefresh = () => {
    // TODO: send back a message to the parent window to refresh magic link
    window.location.reload();
  };

  return (
    <div className="vai-flex vai-flex-col vai-items-center vai-justify-center vai-min-h-screen vai-p-5 vai-bg-background-accent vai-text-center">
      <div className="vai-mb-8">
        <VideaLogoSm />
      </div>

      <h1 className="vai-text-2xl vai-font-semibold vai-text-foreground-base vai-mb-4">
        <Trans>Authentication Error</Trans>
      </h1>

      <p className="vai-text-base vai-text-foreground-muted vai-mb-6 vai-max-w-lg vai-leading-relaxed">
        <Trans>
          There was an issue with your magic link authentication. Please refresh
          the page to try again.
        </Trans>
      </p>

      <button
        onClick={handleRefresh}
        className="vai-bg-sapphire-500 hover:vai-bg-sapphire-600 active:vai-bg-sapphire-700 vai-text-white vai-border-none vai-px-6 vai-py-3 vai-rounded-md vai-text-base vai-font-medium vai-cursor-pointer vai-transition-colors vai-duration-200"
      >
        <Trans>Refresh Page</Trans>
      </button>
    </div>
  );
};

export default MagicLinkErrorPage;
